export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt: string;
  status: 'published' | 'draft';
  categories: string[];
  metaTitle: string;
  metaDescription: string;
  metaRobots: string;
  focusKeyphrase: string;
  createdAt: string;
  updatedAt: string;
  publishedAt?: string;
  author?: string;
  readTime?: string;
  featuredImage?: string;
}

export interface BlogCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

// Shared data storage - this would be replaced with a real database in production
export let mockPublishedPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Getting Started with SEO',
    slug: 'getting-started-with-seo',
    content: '<p>This is a comprehensive guide to SEO basics...</p>',
    excerpt: 'Learn the fundamentals of Search Engine Optimization and how to improve your website rankings.',
    status: 'published',
    categories: ['SEO'],
    metaTitle: 'Getting Started with SEO - Complete Guide',
    metaDescription: 'Learn the fundamentals of SEO and how to improve your website rankings',
    metaRobots: 'index,follow',
    focusKeyphrase: 'SEO basics',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    publishedAt: '2024-01-15T10:00:00Z',
    author: 'Utkrsh Sharma',
    readTime: '8 min read',
    featuredImage: '/images/seo-basics.jpg'
  },
  {
    id: '2',
    title: 'Advanced Content Marketing Strategies',
    slug: 'advanced-content-marketing-strategies',
    content: '<p>Discover advanced techniques for content marketing...</p>',
    excerpt: 'Take your content marketing to the next level with these proven strategies.',
    status: 'published',
    categories: ['Content Marketing'],
    metaTitle: 'Advanced Content Marketing Strategies',
    metaDescription: 'Discover advanced techniques for content marketing success',
    metaRobots: 'index,follow',
    focusKeyphrase: 'content marketing',
    createdAt: '2024-01-16T14:30:00Z',
    updatedAt: '2024-01-16T14:30:00Z',
    publishedAt: '2024-01-16T14:30:00Z',
    author: 'Utkrsh Sharma',
    readTime: '10 min read',
    featuredImage: '/images/content-marketing.jpg'
  },
  {
    id: '3',
    title: 'Technical SEO Best Practices for 2024',
    slug: 'technical-seo-best-practices-2024',
    content: '<p>Master the technical aspects of SEO...</p>',
    excerpt: 'Essential technical SEO practices to boost your website performance.',
    status: 'published',
    categories: ['Technical SEO'],
    metaTitle: 'Technical SEO Best Practices for 2024',
    metaDescription: 'Master the technical aspects of SEO to improve your website performance',
    metaRobots: 'index,follow',
    focusKeyphrase: 'technical SEO',
    createdAt: '2024-01-17T09:15:00Z',
    updatedAt: '2024-01-17T09:15:00Z',
    publishedAt: '2024-01-17T09:15:00Z',
    author: 'Utkrsh Sharma',
    readTime: '12 min read',
    featuredImage: '/images/technical-seo.jpg'
  }
];

export let mockCategories: BlogCategory[] = [
  {
    id: '1',
    name: 'SEO',
    slug: 'seo',
    description: 'Search Engine Optimization tips and strategies',
    createdAt: '2024-01-10T09:00:00Z',
    updatedAt: '2024-01-10T09:00:00Z',
  },
  {
    id: '2',
    name: 'Content Marketing',
    slug: 'content-marketing',
    description: 'Content creation and marketing strategies',
    createdAt: '2024-01-12T11:00:00Z',
    updatedAt: '2024-01-12T11:00:00Z',
  },
  {
    id: '3',
    name: 'Technical SEO',
    slug: 'technical-seo',
    description: 'Technical aspects of SEO',
    createdAt: '2024-01-14T15:00:00Z',
    updatedAt: '2024-01-14T15:00:00Z',
  }
]; 